import actions from './actions'

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/features/tours/store/index.js